export default "__VITE_ASSET__C5KYqH4e__"